import {React,useState} from 'react'
import './Somes.css'
import Button from '@material-ui/core/Button';
import { NavLink } from 'react-router-dom';
import Collapsible from 'react-collapsible';
const Iq2 = () => {
    return (
        <div>
                 <NavLink to='/category/Interview question/5'>
<Button variant="contained" color="primary" style={{float:'right', margin:'25px',marginRight:'80px'}}>Next page -&gt; </Button>
</NavLink> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
<NavLink to='/category/Interview question/3'>
<Button variant="contained" color="primary" style={{float:'left', margin:'25px',marginLeft:'80px'}}>&lt;- Previous page </Button>
</NavLink>
<td>
<div class="concepts">
<a > Aptitude Concepts</a>
</div>
<div>
<h1 class="h1"style={{float:'left'}}> Aptitude Questions</h1>
<h3 style={{float:'right'}}> Topics: <b>Calender</b></h3>
</div>

<br /> <br /> <br /> <br />

<br />

<p class="pq">1) If January 1, 1996, was Monday, what day of the week was January 1, 1997?</p>
<ol class="pointsu">
<li className='list'>Thursday</li>                                                       
<li className='list'>Wednesday</li>
<li className='list'>Friday</li>                                                              
<li className='list'>Sunday</li> 
</ol>
<Collapsible triggerClassName='showanswer' onclick="showhide " trigger='Show Answer'> 
 
<div id="workspace1"></div> 
<div class="testanswer" id="answer1">
<p>The correct option is (B)</p>
<p><strong>Explanation:</strong></p>
<p>The year 1996 is divisible by 4, so it is a leap year with 2 odd days.</p>
<p>As per the question, the first day of the year 1996 was Monday, so the first day of the year 1997 must be two days after Monday. So, it was Wednesday.</p>
</div> </Collapsible>
<br />
<p class="pq">2) The first republic day of India was celebrated on January 26, 1950. What day of the week was it?</p>
<ol class="pointsu">
<li className='list'>Wednesday</li>                                              
<li className='list'>Friday</li>
<li className='list'>Thursday</li>                                                  
<li className='list'>Tuesday</li> 
</ol>
<Collapsible triggerClassName='showanswer' onclick="showhide " trigger='Show Answer'> 
 
<div id="workspace2"></div>
<div class="testanswer" id="answer2">
<p>The correct option is (C)</p>
<p><strong>Explanation:</strong></p>
<p>⇒ 1600 years are divisible by 400, so the year 1600 has 0 odd days.</p>
<p>⇒ 300 years have 1 odd day.</p> 
<p>⇒ 49 years = (12 leap years + 37 years)</p> 
<p>= (12*2, odd days + 37*1, odd days)</p>
<p>= 24 + 37 = 61 odd days</p> 
<p>On dividing 61 by 7, we get remainder 5, so 49 years have 5 odd days.</p> 
<p>⇒From January 26, 1950, to January 26, 1950, we have 26 days.</p>  
<p>26 days = 3 weeks + 5 odd days</p>  
<p>So, total number of odd days = 1 + 5 + 5 = 11 days</p> 
<p>⇒11 days = 1 week + 4 odd days</p> 
<p>4 odd days represent Thursday, so it was Thursday on January 26, 1950.</p>
</div> </Collapsible>
<br />
<p class="pq">3) On February 5, 1998, it was Thursday.  The day of the week on February 5, 1997, was</p>
<ol class="pointsu"> 
<li className='list'>Wednesday</li>                                                  
<li className='list'>Monday</li> 
<li className='list'>Friday</li>                                                            
<li className='list'>Sunday</li> 
</ol>
<Collapsible triggerClassName='showanswer' onclick="showhide " trigger='Show Answer'>  
 
<div id="workspace3"></div>
<div class="testanswer" id="answer3">
<p>The correct option is (A)</p>
<p><strong>Explanation:</strong></p>
<p>1997 was an ordinary year, it had 1 odd day. So, the day on February 5, 1998, would be one day beyond the day on February 5, 1997.</p>
<p>∴ Thursday on February 5, 1998, would be one day beyond the day on February 5, 1997, so the day on February 5, 1997, was Wednesday.</p>
</div> </Collapsible>
<br />
<p class="pq">4) Today is Wednesday, after 68 days, it will be</p>
<ol class="pointsu"> 
<li className='list'>Friday</li>                                                      
<li className='list'>Sunday</li>
<li className='list'>Monday</li>                                                   
<li className='list'>Thursday</li>
</ol>
<Collapsible triggerClassName='showanswer' onclick="showhide " trigger='Show Answer'> 
 
<div id="workspace4"></div>
<div class="testanswer" id="answer4">
<p>The correct option is (C)</p>
<p><strong>Explanation:</strong></p>
<p>Each day of a week is repeated after 7 days, so after 70 days, it will be Wednesday.</p>  
<p>Therefore, after 68 days, it will be Monday.</p> 
</div> </Collapsible>
<br />
<p class="pq">5) What was the day of the week on June 17, 1991?</p>
<ol class="pointsa">
<li className='list'>Tuesday</li>                                                       
<li className='list'>Wednesday</li>
<li className='list'>Friday</li>                                                           
<li className='list'>Monday</li>
</ol>
<Collapsible triggerClassName='showanswer' onclick="showhide " trigger='Show Answer'> 
 
<div id="workspace5"></div>
<div class="testanswer" id="answer5">
<p>The Correct answer; option (D)</p>
<p><strong>Explanation:</strong></p>
<p>June 17, 1991 = (1990 years + period from 01.01.1991 to 17.06.91)</p>
<p>⇒Odd days in 1600 years = 0</p> 
<p>⇒Odd days in the next 300 years = 15 odd days (2 week + 1 odd day) = 1 odd day</p>  
<p>90 years have 22 leap years + 68 ordinary years.</p> 
<p>⇒Number of odd days in 90 years = 22*2 + 68*1 = 112 odd days (16 weeks + 0 odd day) = 0 odd day</p>  
<p>Number of odd days from 01.01.91 to 17.06.91= Jan. (31) + Feb. (28) + March (31) + April (30) + May (31) + June (17) = 168 days</p>
<p>⇒168 days = 24 weeks + 0 odd days</p> 
<p>Total number of odd days = 0 + 1 + 0+ 0 = 1 odd day</p>
<p>1 odd day represents Monday, so the given day was Monday.</p> 
</div> </Collapsible>
<hr />
<p class="pq">6) Which of the following years is not a leap year?</p>
<ol class="pointsu">
<li className='list'>800</li>                                                               
<li className='list'>700</li>
<li className='list'>1600</li>                                                            
<li className='list'>2000</li>
</ol>
<Collapsible triggerClassName='showanswer' onclick="showhide " trigger='Show Answer'> 
 
<div id="workspace1"></div> 
<div class="testanswer" id="answer1">
<p>The Correct answer; option (B)</p>
<p><strong>Explanation:</strong></p>
<p>A century divisible by 400 is a leap year. The years 800, 1600 and 2000 are divisible by 400, so they are leap years.</p> 
<p>The year 700 is not divisible by 400, so it is not a leap year.</p>
</div> </Collapsible> <br />
<p class="pq">7) How many days are there in y weeks y days?</p>
<ol class="pointsu">
<li className='list'>8y</li>                                                                
<li className='list'>8y<sup>2</sup></li>
<li className='list'>16y</li>                                                              
<li className='list'>21y</li>
</ol>
<Collapsible triggerClassName='showanswer' onclick="showhide " trigger='Show Answer'> 
 
<div id="workspace2"></div> 
<div class="testanswer" id="answer2">
<p>The Correct answer; option (A)</p>
<p><strong>Explanation:</strong></p>
<p>There are 7 days in a week, so y weeks will contain 7y days.</p>
<p>∴The required number of days = 7y + y days = 8y days</p>
</div> </Collapsible> <br />
<p class="pq">8) The day on 5<sup>th</sup> April of a year will be the same day on 5<sup>th</sup> of which month of the same year?</p>
<ol class="pointsu">
<li className='list'>5<sup>th</sup> July</li>                                                            
<li className='list'>5<sup>th</sup> August</li>
<li className='list'>5<sup>th</sup> June</li>                                                           
<li className='list'>5<sup>th</sup> October</li> 
</ol>
<Collapsible triggerClassName='showanswer' onclick="showhide " trigger='Show Answer'> 
 
<div id="workspace3"></div> 
<div class="testanswer" id="answer3">
<p>The Correct answer; option (A)</p>
<p><strong>Explanation:</strong></p>
<p>April &amp; July for all years have the same calendar. So, a day on any date of April will be the same day on the corresponding date in July.</p>
<p>∴The same day will fall on 5th July of the same year.</p>
</div> </Collapsible> <br />
<p class="pq">9) It was Saturday on January 1, 2005. Find the day of the week on January 1, 2010.</p>
<ol class="pointsu">
<li className='list'>Tuesday</li>                                                  
<li className='list'>Friday</li>
<li className='list'>Wednesday</li>                                             
<li className='list'>Sunday</li>
</ol>
<Collapsible triggerClassName='showanswer' onclick="showhide " trigger='Show Answer'> 
 
<div id="workspace4"></div> 
<div class="testanswer" id="answer4">
<p>The Correct answer; option (B)</p>
<p><strong>Explanation:</strong></p>
<p>On December 31, 2004, it was Friday.</p> 
<p>Number of odd days from the year 2005 to the year 2009 = 1+1+1+2(leap year) +1 = 6 odd days</p>
<p>∴On December 31, 2009, it was Thursday, so on January 1, 2010, it was Friday.</p> 
</div> </Collapsible> <br />
<p class="pq">10) If it was Wednesday on March 1, 2006, which day was it on March 1, 2002?</p>
<ol class="pointsu">
<li className='list'>Tuesday</li>                                                         
<li className='list'>Friday</li>
<li className='list'>Monday</li>                                                          
<li className='list'>Sunday</li>
</ol>
<Collapsible triggerClassName='showanswer' onclick="showhide " trigger='Show Answer'> 
 
<div id="workspace5"></div> 
<div class="testanswer" id="answer5">
<p>The Correct answer; option (B)</p>
<p><strong>Explanation:</strong></p>
<p>Total number of odd days between the years 2002 and 2006 =</p>
 <p>(2006 - 2002) + 1 = 5 odd days. The year 2004 is a leap year, it has two odd days. So, one extra odd day is added. </p>
<p>So, if it was Wednesday on March 1, 2006, it would be (Wednesday - 5) Friday on March 1, 2002.</p>  
</div>
</Collapsible>
</td>
        </div>
    )
}

export default Iq2
